export function useClipboard() {
  return (url: string) => {
    if (!window.isSecureContext && !navigator.clipboard)
      throw new Error(
        'Cannot copy to clipboard because application is not within a secure context',
      );

    return navigator.clipboard.writeText(url);
  };
}
